import React from 'react';
import capitalize from 'lodash/capitalize';
import { Field } from 'formik';
import ProductSelect from './ProductSelect';
import StatusSelect from './StatusSelect';
import DatePicker from '../../datePicker/DatePicker';
import text from '../../../text';
import AssetIcon from '../../icon/common/AssetIcon';
import { ASSET_ICON_MAP } from '../../../constants/product';
import { get } from 'lodash';
import { DETAILED_STATUS } from '../../../constants/job';
import { formatDate, getNowDate } from '../../../utilities/date';
var ProductRow = function(props) {
    var initialProducts = props.initialProducts, products = props.products, product = props.product, name = props.name;
    var today = new Date();
    return /*#__PURE__*/ React.createElement("tr", {
        className: "ProductRow"
    }, /*#__PURE__*/ React.createElement("td", {
        className: "productCell"
    }, /*#__PURE__*/ React.createElement(AssetIcon, {
        defaultIcon: "question-mark",
        product: ASSET_ICON_MAP[product.productKey]
    }), /*#__PURE__*/ React.createElement(Field, {
        name: "".concat(name, ".productKey")
    }, function(param) {
        var field = param.field, setFieldValue = param.form.setFieldValue;
        var existingProduct = initialProducts.find(function(item) {
            return item.productKey === field.value;
        });
        return existingProduct ? /*#__PURE__*/ React.createElement("span", {
            className: "productLabel"
        }, field.value) : /*#__PURE__*/ React.createElement(ProductSelect, {
            existingProducts: products,
            product: field.value,
            placeholder: text('addNewProduct'),
            onChange: function(option) {
                return setFieldValue(field.name, option.productKey);
            }
        });
    })), /*#__PURE__*/ React.createElement("td", {
        className: "statusCell"
    }, /*#__PURE__*/ React.createElement(Field, {
        name: "".concat(name, ".status")
    }, function(param) {
        var field = param.field, setFieldValue = param.form.setFieldValue;
        return /*#__PURE__*/ React.createElement(StatusSelect, {
            status: field.value,
            placeholder: text('selectStatus'),
            onChange: function(option) {
                return setFieldValue(field.name, capitalize(option.status));
            }
        });
    })), /*#__PURE__*/ React.createElement("td", {
        className: "etaCell"
    }, /*#__PURE__*/ React.createElement(Field, {
        name: "".concat(name, ".expectedAt")
    }, function(param) {
        var field = param.field, _param_form = param.form, setFieldValue = _param_form.setFieldValue, values = _param_form.values;
        return product.status === DETAILED_STATUS.COMPLETED ? text('completedByDate', {
            completedDate: formatDate((product === null || product === void 0 ? void 0 : product.completedAt) || getNowDate())
        }) : /*#__PURE__*/ React.createElement(DatePicker, {
            placeholder: text('selectDate'),
            minDate: today,
            onChange: function(date) {
                return setFieldValue(field.name, date === null || date === void 0 ? void 0 : date.toISOString());
            },
            value: field.value && ![
                DETAILED_STATUS.COMPLETED
            ].includes(get(values, "".concat(name, ".status"))) ? new Date(field.value) : null
        });
    })));
};
export default ProductRow;
